
<template>
  <v-dialog v-model="dialog" scrollable persistent max-width="600px"
  transition="dialog-transition" >
    <v-card>
      <v-card-title>
        <span class="headline">Editando informações do cliente</span>
      </v-card-title>
      <v-card-text class="pt-3">
        <v-form ref="form">
          <v-row>
            <v-col cols='12' class="pa-0">
              <v-menu
                v-model="menu_due"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field :value="$moment(client_aux.social_open_date).format('DD/MM/YYYY')" label="Data de abertura do contrato social" prepend-icon="mdi-calendar" readonly v-on="on" ></v-text-field>
                </template>
                <v-date-picker locale="pt-br" v-model="client_aux.social_open_date" @input="menu_due = false"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols='12' class="pa-0">
              <v-text-field v-model="client_aux.spc_score" label="Score" number :rules="score_validation"></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn cancel @click="closeDialog"></f-btn>
        <f-btn save @click="emitUpdate"></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import { VMoney } from 'v-money'
import validations from '@/mixins/validations.js'

export default {
  name: 'ClientEditClientCreditDialog',
  directives: { money: VMoney },
  mixins:[ validations ],
  props: {
    change_dialog:{
      type: Boolean,
      default: false,
    },
    client:{
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      dialog: true,
      client_aux:{ 
        id: null,
        spc_score: null,
        social_open_date: null
      },
      menu_due: false,
      score_validation: [
        v => ( v >= 1 || !v ) || 'Menor que 1',
        v => ( v <= 9999 || !v ) || 'Maior que 9999',
        v => ( !!v ) || "Campo obrigatório", 
      ]
    }
  },
  methods: {
    setClient(){
      let client = JSON.parse(JSON.stringify(this.client))
      this.client_aux = {
        spc_score: client.data.attributes.spc_score, 
        social_open_date: client.data.attributes.social_open_date,
        id: client.data.attributes.id
      }
    },
    emitUpdate(){
      if(this.$refs.form.validate()){
        this.$emit('update', {new_client: this.client_aux, model: 'basic'})
      }
    },
    closeDialog(){
      this.$emit('close')
    }
  },
  computed:{
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  mounted () {
    this.setClient();
  },
}
</script>
